theme.Currency = (function() {
    var moneyFormat = '${{amount}}';
    var superScript = theme && theme.settings && theme.settings.superScriptPrice;
  
    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }
  
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
  
          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
  
          if (superScript && value && value.includes('.')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
  
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
  
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();

var app = new Vue({
  delimiters: ['${', '}'],
  el: '#insole-finder',
  data: {
    currentStep: 1,
    selected: {},
    isNextStepDisable: true,
    showModal: '',
    stepNames: {
      1: "Was suchen Sie?",
      2: "Was ist Ihr Einsatzbereich?",
      3: "Wie breit ist Ihr Fuß?",
      4: "Wie sieht Ihr Fußgewölbe aus?",
      5: "Welche Schuhgröße tragen Sie?",
      6: "Was für Schuhe tragen Sie?",
      7: "Ihr perfekter Schuh-Typ!"
  },
  nextPrev: {
      1: "Zweck",
      2: "Aktivität",
      3: "Breite",
      4: "Fußgewölbe",
      5: "Größe",
      6: "Schuhart",
      7: "Ergebnis"
  },
    shoeType: {
      "Männer": { 'Laufschuhe': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/bezeckaobuv-removebg.png?v=1690806123` }, 'Sneakers': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/tenisky-removebg.png?v=1690806123` }, 'Sicherheitsschuhe': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/workboot-removebg.png?v=1690806124` }, 'Winterschuhe': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/zimnaobuv-removebg.png?v=1690806124` }, 'Halbschuhe': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/mokasiny-removebg.png?v=1690806122` }, 'Mokassins': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/mokasinky-removebg.png?v=1690806123` }, 'Sommerschuhe': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/letnaobuv-removebg.png?v=1690806123` }, 'Stehberufe': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/pracavstoji-removebg.png?v=1690806123` }, 'Wanderschuhe': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/hikingshoes-removebg.png?v=1690806123` }, 'Arbeitsschlappen': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/pracovneslapky-removebg.png?v=1690806123` }, 'Golf': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/golfovaobuv-removebg.png?v=1690806123` } },
      "Frauen": { 'Laufschuhe': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/bezeckaobuv-removebg.png?v=1690806123` }, 'Sneakers': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/tenisky-removebg.png?v=1690806123` }, 'Sicherheitsschuhe': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/workboot-removebg.png?v=1690806124` }, 'Winterschuhe': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/zimnaobuv-removebg.png?v=1690806124` }, 'Halbschuhe': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/mokasiny-removebg.png?v=1690806122` }, 'Mokassins': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/mokasinky-removebg.png?v=1690806123` }, 'Sommerschuhe': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/letnaobuv-removebg.png?v=1690806123` }, 'Stehberufe': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/pracavstoji-removebg.png?v=1690806123` }, 'Wanderschuhe': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/hikingshoes-removebg.png?v=1690806123` }, 'Arbeitsschlappen': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/pracovneslapky-removebg.png?v=1690806123` }, 'Golf': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/golfovaobuv-removebg.png?v=1690806123` } },
      "Jugendliche": { 'Laufschuhe': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/bezeckaobuv-removebg.png?v=1690806123` }, 'Sneakers': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/tenisky-removebg.png?v=1690806123` }, 'Sicherheitsschuhe': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/workboot-removebg.png?v=1690806124` }, 'Winterschuhe': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/zimnaobuv-removebg.png?v=1690806124` }, 'Halbschuhe': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/mokasiny-removebg.png?v=1690806122` }, 'Mokassins': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/mokasinky-removebg.png?v=1690806123` }, 'Sommerschuhe': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/letnaobuv-removebg.png?v=1690806123` }, 'Stehberufe': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/pracavstoji-removebg.png?v=1690806123` }, 'Wanderschuhe': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/hikingshoes-removebg.png?v=1690806123` }, 'Arbeitsschlappen': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/pracovneslapky-removebg.png?v=1690806123` }, 'Golf': { image: `https://cdn.shopify.com/s/files/1/0663/6086/9087/files/golfovaobuv-removebg.png?v=1690806123` } }
  },


   removableInsole: ['Ja','Nein','Ich weiß nicht'],
    productHandles: window.products,
    steps: [
    {
        name: "Zweck",
      	heading: 'Ich suche Erleichterung bei:',
        isMulti: true,
      	hasChild: false,
        values: [
          {
           name: "Fersenschmerzen",
           isPopup: false,
           content: '',
           image: 'https://cdn.shopify.com/s/files/1/0613/1240/1631/files/plantar.png?v=1644402828', 
           values: []
          },
          {
           name: "Schmerzen im Lenden- und Rückenbereich",
           isPopup: false,
           content: '',
           image: 'https://cdn.shopify.com/s/files/1/0663/6086/9087/files/bolest-krizov_0df63add-8273-40f2-b1c1-7440bd74d0ea.png?v=1675678121',
           values: []
          },
          {
           name: "Knieschmerzen",
           isPopup: false,
           content: '',
           image: 'https://cdn.shopify.com/s/files/1/0663/6086/9087/files/bolest-kolena_771fbbea-a74e-4e70-8db0-a5c2457fafa8.png?v=1676891668',
           values: []
          },
          {
           name: "Knöchelschmerzen",
           isPopup: false,
           content: '',
           image: 'https://cdn.shopify.com/s/files/1/0663/6086/9087/files/bolest-clenku.png?v=1676891796',
           values: []
          },
          {
            name: "Spannschmerzen",
            isPopup: false,
            content: '',
            image: 'https://cdn.shopify.com/s/files/1/0663/6086/9087/files/forefoot.png?v=1690798200',
            values: []
          },
          {
            name: "Diabetische Neuropathie",
            isPopup: false,
            content: '',
            image: 'https://cdn.shopify.com/s/files/1/0663/6086/9087/files/diabetic.png?v=1690798699',
            values: []
          },
          {
            name: "Gleichgewichtstraining",
            isPopup: false,
            content: '',
            image: 'https://cdn.shopify.com/s/files/1/0613/1240/1631/files/cushion.png?v=1644402828',
            values: []
          },
          {
            name: "Alle oben genannten",
            isPopup: false,
            content: '', 
            image: 'https://cdn.shopify.com/s/files/1/0613/1240/1631/files/all.png?v=1644402828',
            values: []
          }
        ]
      },
      {
        name: "Aktivität",
        heading: 'Was sind Ihre Tätigkeiten?',
        isMulti: true,
        hasChild: false,
        values: [
          {
            name: "Laufen/Stoßaktivitäten/Sport",
            isPopup: false,
            content: '',
            image: 'https://cdn.shopify.com/s/files/1/0613/1240/1631/files/Running.png?v=1646222323',
            values: []
          },
          {
            name: "Golf/Stabilisierungsaktivitäten",
            isPopup: false,
            content: '',
            image: 'https://cdn.shopify.com/s/files/1/0613/1240/1631/files/Golf_beb87a45-a306-4238-b60b-75724835975c.png?v=1646222323',
            values: []
          },
          {
            name: "Tägliches Gehen/Spazierengehen/Gärtnern",
            isPopup: false,
            content: '',
            image: 'https://cdn.shopify.com/s/files/1/0613/1240/1631/files/Walking.png?v=1646222323',
            values: []
          },
          {
            name: "Krankenschwester/Medizinisches Personal",
            isPopup: false,
            content: '',
            image: 'https://cdn.shopify.com/s/files/1/0613/1240/1631/files/Nurse.png?v=1646222323',
            values: []
          },
          {
            name: "Industriearbeiter/Fabrikarbeiter",
            isPopup: false,
            content: '',
            image: 'https://cdn.shopify.com/s/files/1/0613/1240/1631/files/Industrial.png?v=1646222323',
            values: []
          },
          {
            name: "Rettungsdienst/Feuerwehrmann/Polizist",
            isPopup: false,
            content: '',
            image: 'https://cdn.shopify.com/s/files/1/0613/1240/1631/files/Field-officer.png?v=1646222323',
            values: []
          },
          {
            name: "Einzelhandel/Stehberufe/Lehrer",
            isPopup: false,
            content: '',
            image: 'https://cdn.shopify.com/s/files/1/0613/1240/1631/files/Retail.png?v=1646222323',
            values: []
          },
          {
            name: "Keine",
            isPopup: false,
            content: '',
            image: 'https://cdn.shopify.com/s/files/1/0613/1240/1631/files/Activity-none.png?v=1646222323',
            values: []
          }
        ]
      },
      {
        name: "Breite",
        heading: 'Wie breit ist Ihr Fuß?',
        isMulti: false,
        hasChild: false,
        values: [
          {
            name: "Breit",
            isPopup: false,
            image: 'https://cdn.shopify.com/s/files/1/0613/1240/1631/files/wide-foot.png?v=1646222932', 
            content: 'Ihr Fuß ist breiter und einige schmalere/niedrig geschnittene Schuhe sind für Sie unbequem.',
            values: []
          },
          {
            name: "Normal",
            isPopup: false,
            image: 'https://cdn.shopify.com/s/files/1/0613/1240/1631/files/Normal-foot.png?v=1646222932', 
            content: 'Ihr Fuß hat eine normale Breite und Sie haben keine Probleme mit unbequemen Schuhen aufgrund von Breite/Volumen.',
            values: []
          },
          {
            name: "Schmal",
            isPopup: false,
            image: 'https://cdn.shopify.com/s/files/1/0613/1240/1631/files/Narrow-foot.png?v=1646222932', 
            content: 'Sie haben einen schlanken oder schmalen Fuß und finden, dass einige breitere Schuhe mit mehr Volumen zu voluminös oder zu locker sind.',
            values: []
          },
          {
            name: "Ich weiß nicht",
            isPopup: true,
            image: 'https://cdn.shopify.com/s/files/1/0613/1240/1631/files/Not-sure.png?v=1646222933', 
            content: '',
            values: []
          }
        ]
      },
       {
        name: "Fußgewölbe",
        heading: 'Wie sieht Ihr Fußgewölbe aus?',
        isMulti: false,
        hasChild: false,
        values: [
          {
            name: "Flach",
            isPopup: false,
            image: 'https://cdn.shopify.com/s/files/1/0613/1240/1631/files/Arch-flate.png?v=1646223549', 
            content: '',
            values: []
          },
          {
            name: "Normal",
            isPopup: false,
            image: 'https://cdn.shopify.com/s/files/1/0613/1240/1631/files/Arch-normal.png?v=1646223549', 
            content: '',
            values: []
          },
          {
            name: "Hoch",
            isPopup: false,
            image: 'https://cdn.shopify.com/s/files/1/0613/1240/1631/files/Arch-high.png?v=1646223549', 
            content: '',
            values: []
          },
          {
            name: "Ich weiß nicht",
            isPopup: true,
            image: 'https://cdn.shopify.com/s/files/1/0613/1240/1631/files/Not-sure.png?v=1646222933', 
            content: '',
            values: []
          }
        ]
      },
      {
        name: "Größe",
        heading: 'Welche Schuhgröße haben Sie?',
        isMulti: false,
        hasChild: true,
        values: [
          {
            name: "Männer",
            isPopup: false,
            image: '', 
            content: '',
            values: ['34-35','36-37','38-39','40-41','42-43','44-45','46-47']
          },
          {
            name: "Frauen",
            isPopup: false,
            image: '', 
            content: '',
            values: ['34-35','36-37','38-39','40-41','42-43','44-45','46-47']
          },
          {
            name: "Jugendliche",
            isPopup: false,
            image: '', 
            content: '',
            values: ['34-35','36-37','38-39','40-41','42-43','44-45','46-47']
          }
        ]
      }
    ],
    popups: [
      
    ]

  },
  methods: {
    isObject: function(arr){
      if(typeof arr === 'object') {
        return true;
      }else{
      	return false;
      }
  	},
    selectOption: function(event){
      event.preventDefault();
      
      
      if($(event.currentTarget).parents('.js--active-question--target').hasClass('multiple')){ 
        $(event.currentTarget).parents('.js--select-answer--trigger').toggleClass('selected');
      }else{ 
        $('.js--active-question--target').find('.js--select-answer--trigger').removeClass('selected');
        $(event.currentTarget).parents('.js--select-answer--trigger').toggleClass('selected');
      }
                                  
      if($(event.currentTarget).parents('.js--select-answer--trigger').find('.one-expandable-content').length > 0){
		var $submenu = $(event.currentTarget).parents('.js--select-answer--trigger').find('.one-expandable-content').slideToggle(200);
        $('.step-content').find('.js--select-answer--trigger .one-expandable-content').not($submenu).slideUp('fast');
      }else{
      	$(event.currentTarget).parents('.js--select-answer--trigger').find('.expandable-content').slideToggle(200);
      }
      
      var action_title = $(event.currentTarget).parents('.js--active-question--target').attr('data-action');
      if($(event.currentTarget).hasClass('show-popup')){
        this.showModal = action_title.toLowerCase().replaceAll(' ', '-')+'-popup';
        this.triggerModal(event, action_title.toLowerCase().replaceAll(' ', '-')+'-popup');
      }
      
      if($('.js--active-question--target').hasClass('multiple')){
        var selected_data = {};
        $('.js--active-question--target.multiple .selected').each(function(e){
          var title = 'in'+$(this).attr('data-title');
          selected_data[title] = $(this).attr('data-value');
        });
        this.$set(this.selected, action_title, selected_data);
      }else{
        if(!$(event.currentTarget).parents('.step-content').hasClass('has-child')){
          var value = $('.js--active-question--target .selected').attr('data-value');
          this.$set(this.selected, action_title, value);
        }
      }
      
      if(!$(event.currentTarget).parents('.step-content').hasClass('has-child')){
        this.isNextStepDisable = false;
      }
    },
    selectOptionChild: function(event){ 
      event.preventDefault();
      $(event.currentTarget).parents('.js--active-subquestions').find('li').removeClass('selected');
      $(event.currentTarget).parent().addClass('selected');
      var parent_title = $('.finder--main-col .js--active-question--target').attr('data-action');
      
      var selected_data = {};var _self = this;
        $('.js--active-question--target .selected').each(function(e){ 
           var title = $(this).attr('data-title'); 
           selected_data[title] = $(this).attr('data-value');                                                
           if(parent_title == 'Schuhe'){
             if($(this).data('value') == 'Ja'){ 
               selected_data[title] = 'Herausnehmbarer Einsatz';
             }else if($(this).data('value') == 'Nein'){  
               selected_data[title] = 'Nicht herausnehmbarer Einsatz';
             }else if($(this).data('value') == 'Ich weiß nicht'){ 
               selected_data[title] = 'Herausnehmbarer Einsatz';
               _self.showModal = true;
             }
           }
        });
      
       console.log('selected_data=', selected_data, 'parent_title=', parent_title);
      this.$set(this.selected, parent_title, selected_data);
      this.isNextStepDisable = false;
    },
    nextStep: function(event){
      event.preventDefault();
      this.isNextStepDisable = true;
      if(this.currentStep == 6){ console.log('show loader');
        this.loadingScreen();
        this.getProducts(this.productHandles);
      }
      ++this.currentStep;
  
    },
    jumpToStep: function(event){
      if($(event.target).data('step') < this.currentStep){
        this.currentStep = $(event.target).data('step');
      }
    },
    jumpToStepFromNext: function(event){
        this.currentStep = $(event.target).data('step');
      
    },
    triggerModal: function(event, target){ 
      event.preventDefault(); console.log('triggerModal');
      $('body').addClass('popup-opened');
      this.showModal = target;
    },
    closeModal: function(event){ 
      event.preventDefault();
      $('body').removeClass('popup-opened');
      this.showModal = false;
    },
    accordion: function(event){
      $(event.target).toggleClass('opened');
      $(event.target).parents('.profile-summary').find('.profile-answers').slideToggle(200);
    },
    loadingScreen: function(){
      $('.finder--loading-screen').removeClass('hide');
      var elem = $('.finder--loading-screen .meter .progress')[0];
      var width = 1;
      var id = setInterval(frame, 20);

      function frame() {
        if (!elem || width >= 100) {
          clearInterval(id);
          $('.finder--loading-screen').addClass('hide');
          $('.finder--loading-screen .meter .progress').css('width', 0);
        } else {
          width++;
          var move = Math.floor((Math.random() * 4) + 1);
          elem.style.width = width + move + '%';
        }
      }
    },
    template: $('#products-container').html() ? Handlebars.compile($('#products-container').html()) : '',
    getProductByHandle: function(handle){
      return $.ajax({
        url: '/products/' + handle + '?view=json',
        handle: handle,
        //dataType:"json",
        beforeSend: function (jqXHR, settings) {
          jqXHR.url = settings.url;
          jqXHR.handle = settings.handle;
        },
      });
    },
    getProducts: function(productsHandleArray){
      var deferreds = productsHandleArray.map(function(handle){
        return this.getProductByHandle(handle);
      }.bind(this));
      var _self = this;

      $.when.apply($, deferreds).then(function(){ 
        var productsResponse = arguments;
        var products = [];
        for (var i = 0; i < productsResponse.length; i++){
          var resp = productsResponse[i];
          if (resp[1] == "success") {
            resp[0] = JSON.parse(resp[0]); 
            console.log('------------product=', resp[0]);
            var result_product = false;var size_found = false;var matchedTags = 0;
            
            for (var j = 0; j < resp[0].product.variants.length; j++){
              if(resp[0].product.variants[j].name.includes(_self.selected['Größe']['size'])){
                size_found = true;
//                 matchedTags = 1;
                resp[0].product.result_variant_id = resp[0].product.variants[j].id;
                break;
              }
            }
            if(size_found){
              Object.entries(_self.selected).forEach(([key, value]) => {
                if(_self.isObject(value)){
                  var stepValueFound = false; 
                  Object.entries(value).forEach(([k, v]) => {
                    if(!stepValueFound){ 
                      if(resp[0].product.tags.includes(v)){
                        result_product = true;
                        stepValueFound = true; 
                        ++matchedTags;
                        return false;
                      }
                    }
                  });
                }else{
                  if(resp[0].product.tags.includes(value)){
                    result_product = true; 
                    ++matchedTags;
                  }
                }
              });

              resp[0].product.price = theme.Currency.formatMoney(resp[0].product.price, theme.settings.moneyFormat);
              resp[0].product.variants[0].price = theme.Currency.formatMoney(resp[0].product.variants[0].price, theme.settings.moneyFormat);
              
              console.log('result='+result_product +' && '+ matchedTags +' of '+ Object.keys(_self.selected).length);
              if(result_product && matchedTags == Object.keys(_self.selected).length){
                products.push(
                  resp[0].product
                );
              }
              
            }
            
          }
        }
        //console.log(productsResponse);
        console.log('result products', products);
        var type_size_selected = '';
        if(products.length > 0){
          var productsHTML =  _self.template({
            products: products
          });
          type_size_selected = _self.selected['Größe']['type']+' '+_self.selected['Größe']['size'];
        }else{
          $('.finder--results .profile-grid--container').addClass('no-result');
          var productsHTML = '<div class="no-results-wrapper"><div class="product--container"><h5>No products found</h5></div></div>';
        }
       
        $('.insole-result-products').html(productsHTML);
        $('.type-and-size').html(type_size_selected);
      }).fail(function () {
        //console.log(this, productsHandleArray);
        var failedHandle = this.handle;
        var handles = productsHandleArray.filter(function (handle) {
          return handle != failedHandle;
        });
        //console.log(handles);
        if (handles.length == 0) {
          return;
        }
//         _self.getProducts(_self.products);
      });
    }
  }
});